export default __webpack_public_path__ + "static/media/chevron-right-double.67c4d5f0.svg";